var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"help"}},[_c('h2',[_vm._v(_vm._s(_vm.data.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }